export const colorPalette = {
    grey50: "#F8FAFB",
    grey100: "#F2F5F7",
    grey200: "#D9E0E8",
    grey220: "#CCD4DE",
    grey300: "#A6B7C9",
    grey400: "#6784A2",
    grey600: "#485E75",
    grey800: "#2B3948",
    blue20: "#F3FBFF",
    blue50: "#E8F6FF",
    blue100: "#D2EDFF",
    blue200: "#A5DBFF",
    blue400: "#5CB3FF",
    blue600: "#0A6FE8",
    blue700: "#0253B6",
    blue800: "#0253B6",
    blue900: "#003873",
    purple100: "#F1EDFB",
    purple200: "#E1D6FC",
    purple300: "#C9B9F0",
    purple400: "#B39DE4",
    purple500: "#9C7EDB",
    purple600: "#8053CE",
    purple700: "#6A2AC0",
    purple800: "#4D1F8C",
    purple900: "#31145A",
    purple1000: "#17092B",
    cyan100: "#E6F4FC",
    cyan200: "#C2E9FF",
    cyan300: "#85D0FF",
    cyan400: "#38B3FF",
    cyan500: "#1295ED",
    cyan600: "#006EBD",
    cyan700: "#004F94",
    cyan800: "#003666",
    cyan900: "#012646",
    cyan1000: "#130F2F",
    teal100: "#E4F5F5",
    teal200: "#C8F0EE",
    teal300: "#91DED8",
    teal400: "#61D6D0",
    teal500: "#1BA3A1",
    teal600: "#0C7E7D",
    teal700: "#0C6968",
    teal800: "#0B4745",
    teal900: "#083130",
    teal1000: "#041B1B",
    pink100: "#FEEBEF",
    pink200: "#FFD7DE",
    pink300: "#FDB0BF",
    pink400: "#FC849F",
    pink500: "#FB527E",
    pink600: "#D70059",
    pink700: "#A70045",
    pink800: "#7E0034",
    pink900: "#550023",
    pink1000: "#2D0013",
    tomato50: "#FEEEEE",
    tomato100: "#FDE5E5",
    tomato200: "#FFD2D0",
    tomato300: "#FAAFAC",
    tomato400: "#FC837E",
    tomato500: "#E72B2B",
    tomato600: "#D11A26",
    tomato700: "#B71520",
    tomato800: "#751A0F",
    tomato900: "#4C1109",
    tomato1000: "#280805",
    celery100: "#E5F8DE",
    celery200: "#CAF4B9",
    celery300: "#95DF70",
    celery400: "#6AC22A",
    celery500: "#5AA126",
    celery600: "#447A1D",
    celery700: "#345D16",
    celery800: "#254310",
    celery900: "#172A0A",
    celery1000: "#0B1304",
    dataBlue100: "#EBF1FC",
    dataBlue200: "#D1E1FF",
    dataBlue300: "#A9C7FE",
    dataBlue400: "#7BA7FE",
    dataBlue500: "#4985FD",
    dataBlue600: "#1360FB",
    dataBlue700: "#0248CA",
    dataBlue800: "#02359D",
    dataBlue900: "#01246A",
    dataBlue1000: "#011641",
    yellow100: "#FEF7D4",
    yellow200: "#FCE66A",
    yellow300: "#F1CD1B",
    yellow400: "#D4B804",
    yellow500: "#B29202",
    yellow600: "#8A6C01",
    yellow700: "#685501",
    yellow800: "#483B01",
    yellow900: "#2E2300",
    yellow1000: "#1A1501",
    orange100: "#FFF1E0",
    orange200: "#FFE4C4",
    orange300: "#FFC582",
    orange400: "#FF8F2E",
    orange500: "#EB6702",
    orange600: "#B25300",
    orange700: "#8B3F00",
    orange800: "#5F2B00",
    orange900: "#3F1B00",
    orange1000: "#230F00",
    green50: "#EAFBEF",
    green100: "#DEF8E6",
    green200: "#B9F4CC",
    green300: "#6EDF97",
    green400: "#2CCB71",
    green500: "#2CA460",
    green600: "#217C49",
    green700: "#1A5F38",
    green800: "#124428",
    green900: "#0C2B19",
    green1000: "#05140C",
    violet100: "#EAEAFE",
    violet200: "#D7D7FE",
    violet300: "#B4B5FA",
    violet400: "#9A9BEE",
    violet500: "#7E7EF1",
    violet600: "#5659DA",
    violet700: "#3F42B2",
    violet800: "#2C2F7E",
    violet900: "#1D1E52",
    violet1000: "#0E0F28",
    magenta100: "#F4EBFE",
    magenta200: "#EBD7FE",
    magenta300: "#D8B3FA",
    magenta400: "#C88DF8",
    magenta500: "#B86BEF",
    magenta600: "#A428E7",
    magenta700: "#8700C0",
    magenta800: "#64008F",
    magenta900: "#43005F",
    magenta1000: "#240033",
};
/** @mixes Illustration-Colors */
export const systemColors = {
    grey50: colorPalette.grey50,
    grey100: colorPalette.grey100,
    grey200: colorPalette.grey200,
    grey220: colorPalette.grey220,
    grey300: colorPalette.grey300,
    grey400: colorPalette.grey400,
    grey600: colorPalette.grey600,
    grey800: colorPalette.grey800,
    blue50: colorPalette.blue50,
    blue100: colorPalette.blue100,
    blue200: colorPalette.blue200,
    blue400: colorPalette.blue400,
    blue600: colorPalette.blue600, // Sky Blue
    blue800: colorPalette.blue800,
    blue900: colorPalette.blue900, // Indigo Blue
    green100: "#D6F5EB", // Ocean Green Light
    green300: "#6CDAB6", // Ocean Green
    /**
     * @fires It is Illustration-Green-400
     * @see green800 for System-Green-400
     */
    green400: "#33CC99", // Ocean Green
    green600: "#29A67C", // Ocean Green Dark
    /** System Green 400 */
    green800: "#1E785A", // System Green 400
    orange100: "#FEEDEC", // Tart Orange Light
    orange200: "#FDD9D8", // Tart Orange
    orange300: "#F87E77", // Tart Orange
    orange400: "#F64F45", // Tart Orange
    orange600: "#C43E37", // Tart Orange Dark
    red100: "#FDDCDA",
    red400: "#C91309",
    /**
     * @fires It is Illustration-Yellow-100
     * @see yellow200 for System-Yellow-100
     */
    yellow100: "#FDFAE8", // Sunny Yellow Light
    /** System Yellow 100 */
    yellow200: "#FCF5D1", // System Yellow 100
    /**
     * @fires It is Illustration-Yellow-400
     * @see yellow800 for System-Yellow-400
     */
    yellow400: "#EFCF1A", // Sunny Yellow
    yellow600: "#D1B517", // Sunny Yellow Dark
    /** System Yellow 400 */
    yellow800: "#A15C0E", // System Yellow 600
    shadow100: "#2B394814", // 8%
    shadow200: "#2B394829", // 16%
    white: "#FFFFFF", // Paper
    black: "#13191F", //  Rich Black
};
export const dataVisualizationColors = {
    darkPurple: colorPalette.purple700,
    lightPurple: colorPalette.purple500,
    pink: colorPalette.pink500,
    peach: colorPalette.pink700,
    orange: colorPalette.orange500,
    orange200: colorPalette.orange200,
    sunshineYellow: colorPalette.yellow500,
    mintGreen: colorPalette.green500,
    mossGreen: colorPalette.celery600,
    teal: colorPalette.teal500,
    violet: colorPalette.violet600,
    blue50: colorPalette.blue50,
    blue100: colorPalette.blue100,
    purple500: colorPalette.purple500,
    purple700: colorPalette.purple700,
    purple800: colorPalette.purple800,
    cyan500: colorPalette.cyan500,
    cyan900: colorPalette.cyan900,
    teal500: colorPalette.teal500,
    teal700: colorPalette.teal700,
    pink500: colorPalette.pink500,
    pink700: colorPalette.pink700,
    tomato50: colorPalette.tomato50,
    tomato100: colorPalette.tomato100,
    tomato400: colorPalette.tomato400,
    tomato500: colorPalette.tomato500,
    tomato600: colorPalette.tomato600,
    tomato900: colorPalette.tomato900,
    celery600: colorPalette.celery600,
    dataBlue800: colorPalette.dataBlue800,
    yellow100: colorPalette.yellow100,
    yellow200: colorPalette.yellow200,
    yellow500: colorPalette.yellow500,
    orange500: colorPalette.orange500,
    green50: colorPalette.green50,
    green100: colorPalette.green100,
    green400: colorPalette.green400,
    green500: colorPalette.green500,
    violet600: colorPalette.violet600,
    magenta600: colorPalette.magenta600,
    grey300: colorPalette.grey300,
};
export const twoToneColors = {
    purple: { background: colorPalette.purple100, text: colorPalette.purple600 },
    cyan: { background: colorPalette.cyan100, text: colorPalette.cyan600 },
    teal: { background: colorPalette.teal100, text: colorPalette.teal600 },
    pink: { background: colorPalette.pink100, text: colorPalette.pink600 },
    celery: { background: colorPalette.celery100, text: colorPalette.celery600 },
    dataBlue: { background: colorPalette.dataBlue100, text: colorPalette.dataBlue600 },
    orange: { background: colorPalette.orange100, text: colorPalette.orange600 },
    violet: { background: colorPalette.violet100, text: colorPalette.violet600 },
    magenta: { background: colorPalette.magenta100, text: colorPalette.magenta600 },
    yellow: { background: colorPalette.yellow100, text: colorPalette.yellow600 },
    grey: { background: colorPalette.grey100, text: colorPalette.grey600 },
};
export const threeToneColors = {
    purple: {
        tone100: colorPalette.purple100,
        tone600: colorPalette.purple600,
        tone700: colorPalette.purple700,
    },
    cyan: {
        tone100: colorPalette.cyan100,
        tone600: colorPalette.cyan600,
        tone700: colorPalette.cyan700,
    },
    teal: {
        tone100: colorPalette.teal100,
        tone600: colorPalette.teal600,
        tone700: colorPalette.teal700,
    },
    pink: {
        tone100: colorPalette.pink100,
        tone600: colorPalette.pink600,
        tone700: colorPalette.pink700,
    },
    celery: {
        tone100: colorPalette.celery100,
        tone600: colorPalette.celery600,
        tone700: colorPalette.celery700,
    },
    dataBlue: {
        tone100: colorPalette.dataBlue100,
        tone600: colorPalette.dataBlue600,
        tone700: colorPalette.dataBlue700,
    },
    orange: {
        tone100: colorPalette.orange100,
        tone600: colorPalette.orange600,
        tone700: colorPalette.orange700,
    },
    violet: {
        tone100: colorPalette.violet100,
        tone600: colorPalette.violet600,
        tone700: colorPalette.violet700,
    },
    magenta: {
        tone100: colorPalette.magenta100,
        tone600: colorPalette.magenta600,
        tone700: colorPalette.magenta700,
    },
    yellow: {
        tone100: colorPalette.yellow100,
        tone600: colorPalette.yellow600,
        tone700: colorPalette.yellow700,
    },
    grey: {
        tone100: colorPalette.grey100,
        tone600: colorPalette.grey600,
        tone700: colorPalette.grey800,
    },
};
export const styledTheme = {
    fontSize: {
        headerBig: "34px",
        headerSmaller: "14px",
        h1: "40px",
        h2: "32px",
        h3: "28px",
        h4: "24px",
        h5: "20px",
        large: "18px",
        middle: "16px",
        small: "14px",
        extraSmall: "12px",
    },
    media: {
        sm: "576px",
        md: "768px",
        lg: "992px",
        xl: "1320px",
    },
    spacing: {
        sp4: "4px",
        sp6: "6px",
        sp8: "8px",
        sp12: "12px",
        sp16: "16px",
        sp20: "20px",
        sp24: "24px",
        sp32: "32px",
        sp48: "48px",
        sp64: "64px",
        sp80: "80px",
    },
    /** @mixes Illustration-Colors */
    systemColors,
    dataVisualizationColors,
    twoToneColors,
    threeToneColors,
};
